import "../../exam/components/question/QuestionGrid/QuestionGrid.css";
import {
  getExerciseQuestionStatus,
  groupExerciseQuestionsBySection,
} from "../utils/exerciseExamUtils";

const STATUS_CLASSES = {
  answered: "question-box answered",
  unanswered: "question-box unanswered",
  marked: "question-box marked",
  answered_marked: "question-box answered-marked",
  current: "question-box current",
  unvisited: "question-box not-visited",
};

const ExerciseQuestionGrid = ({
  questions = [],
  currentIndex = 0,
  onSelect,
  showSectionTitles = true,
}) => {
  const grouped = groupExerciseQuestionsBySection(questions);

  return (
    <div>
      {grouped.map((group) => (
        <div key={group.section} className="question-section">
          {showSectionTitles ? (
            <h6 className="question-section-title">{group.section}</h6>
          ) : null}

          <div className="question-grid">
            {group.questions.map(({ question, index }) => {
              const status = getExerciseQuestionStatus(
                question,
                index,
                currentIndex
              );

              return (
                <div
                  key={question.qid ?? index}
                  className={STATUS_CLASSES[status] || STATUS_CLASSES.unvisited}
                  onClick={() => onSelect?.(index)}
                >
                  {index + 1}
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ExerciseQuestionGrid;
